export default __webpack_public_path__ + "static/media/803.19ca82f0.gif";